export default __webpack_public_path__ + "static/media/Bb6.89c541e8.mp3";